import { Routes, Route } from "react-router-dom";
import { Suspense, lazy, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { AuthenticationServiceProvider } from "../services/authentication.service";
import { PermissionProvider } from "../contexts/PermissionContext";
import MasterLayout from "./master.layout";
import { PrivateRoute } from "../components";
import roles from "../utils/constants/roles";

const Login = lazy(() => import("../pages/login"));
const NotFoundPage = lazy(() => import("../pages/error/not.found"));
const MaintenancePage = lazy(() => import("../pages/maintenance"));
const TemplatesPage = lazy(() => import("../pages/templates"));
const TemplateBuilderPage = lazy(() => import("../pages/templates/builder"));
const TemplatesLayout = lazy(() => import("../pages/templates/TemplatesLayout"));
const HomePage = lazy(() => import("../pages/home"));
const EnquiriesPage = lazy(() => import("../pages/enquiries"));
const EnquiryDetailPage = lazy(() => import("../pages/enquiryDetail"));
const CentresPage = lazy(() => import("../pages/centres"));
const CentreCalendarPage = lazy(() => import("../pages/centre-calendar"));
const EnrolmentsPage = lazy(() => import("../pages/enrolments"));
const WaitlistsPage = lazy(() => import("../pages/waitlists"));

function RemoveBootstrapShell() {
  useEffect(() => {
    const shell = document.getElementById("app-bootstrap-shell");
    if (shell) shell.remove();
  }, []);
  return null;
}

export default function ProviderLayout() {
  return (
    <AuthenticationServiceProvider>
      <PermissionProvider>
        <RemoveBootstrapShell />
        <ToastContainer />
        <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute roles={roles.ALL_ROLES}>
                <MasterLayout />
              </PrivateRoute>
            }
          >
            <Route
              index
              element={
                <PrivateRoute roles={roles.ALL_ROLES}>
                  <HomePage />
                </PrivateRoute>
              }
            />
            <Route
            path="/enquiries"
            element={
              <PrivateRoute roles={roles.ALL_ROLES}>
                <EnquiriesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/enquiries/:enquiryId"
            element={
              <PrivateRoute roles={roles.ALL_ROLES}>
                <EnquiryDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/centres"
            element={
              <PrivateRoute roles={roles.ALL_ROLES}>
                <CentresPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/calendar"
            element={
              <PrivateRoute roles={roles.ALL_ROLES}>
                <CentreCalendarPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/enrolments"
            element={
              <PrivateRoute roles={roles.RECORD_SEARCH_ROLES}>
                <EnrolmentsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/waitlists"
            element={
              <PrivateRoute roles={roles.RECORD_SEARCH_ROLES}>
                <WaitlistsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/maintenance"
            element={
              <PrivateRoute roles={roles.SYSTEM_ADMINS}>
                <MaintenancePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/templates"
            element={
              <PrivateRoute roles={roles.TEMPLATE_ROLES}>
                <TemplatesLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<TemplatesPage />} />
            <Route path="editor" element={<TemplateBuilderPage />} />
            <Route path="editor/:templateId" element={<TemplateBuilderPage />} />
          </Route>
          </Route>
          
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </Suspense>
      </PermissionProvider>
    </AuthenticationServiceProvider>
  );
}
